<template>
  <ImpressaoModal
    header="Requisição Médica"
    :ref="refs"
    size="lg"
    :pageSelect="true"
    :agrupada="true"
    @acao="imprimirPrescricao"
    @changedata="updateDados"
    idModal="prescricaomodalimpressao"
  >
    <HTMLReport
      v-if="dados && paciente && medico && unidade"
      id="imprimir-prescricao"
      v-show="false"
      :pageSize="pageSize"
    >
      <div style="font-size: 20pt;">
        <br />
        <span>
          Solicito para:
          <strong>{{ paciente.st_nome }}</strong>
        </span>
        <br />
        <br />
        <ul class="list-group border-0">
          <li class="list-group-item p-1 border-0" v-for="(item, id) in dados.items" :key="id">
            <div style="font-size: 20pt;">{{ item.item.st_procedimento }}</div>
            <div v-if="item.st_observacoes" class="ml-3">{{ item.st_observacoes }}</div>
          </li>
        </ul>
        <br />
        <br />
        <span v-if="dados.cid">
          <strong style="font-size: 20pt;">CID: {{ dados.cid.st_codigo }}</strong>
        </span>
        <br />
        <br />
        <br />
        <span style="font-size: 20pt;">{{ assinaturaReport() }}</span>
      </div>
      <template v-slot:rodape>
        <rodape-medico :medico="medico" />
      </template>
    </HTMLReport>
  </ImpressaoModal>
</template>

<script>
import HTMLReport from "../HTMLReport";
import * as moment from "moment";
import ImpressaoModal from "../shared/ModalImpressao";
import RodapeMedico from "./RodapeMedico.vue";
import "../../../../public/estilosimpressao/estilosa4.css";
import "../../../../public/estilosimpressao/estilosa5.css";
// import $ from "jquery";

export default {
  data() {
    return {
      unidade: null,
      pageSize: "",
      dados: {}
    };
  },

  props: ["paciente", "medico"],

  components: { 
    HTMLReport, 
    ImpressaoModal,
    RodapeMedico
  },
  
  methods: {
    assinaturaReport() {
      return (
        ( ( this.unidade.endereco && this.unidade.endereco.cidade ) ? this.unidade.endereco.cidade.st_cidade : "" ) +
        ",  " +
        ( 
          this.dados.fl_exibir_data !== null && !this.dados.fl_exibir_data ? '_____/______/_________' : 
            ( 
              this.dados.dt_referencia ? moment(this.dados.dt_referencia, 'YYYY-MM-DD').format("DD [de] MMMM [de] YYYY") : 
              moment().format("DD [de] MMMM [de] YYYY") 
            )
        )
      );
    },
    abrirModal(dadosIniciais) {
      this.dados = dadosIniciais;
      console.log("dados prescrição", dadosIniciais);
      // this.pageSize = this.$refs[this.refs].dados.pageSize;
      this.pageSize = this.$util.getCookie('page-size');
      if ( !this.pageSize )
        this.pageSize = 'A4';

      // this.$refs[this.refs].abrirModalImpressao();
      this.$nextTick(() => {
        this.$refs[this.refs].abrirModalImpressao();
      });
    },
    imprimirPrescricao(dados) {
      this.imprimirRequisicao(dados);
    },
    imprimirRequisicao(dados) {
      let configPrint;
      this.dados = dados;
      this.pageSize = this.$util.getCookie('page-size');

      if (this.pageSize === "A4") {
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
            "https://api.klingo.app/css/estiloa4.css"
          ]
        };
      } else if (this.pageSize === "A5") {
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
            "https://api.klingo.app/css/estiloa5.css"
          ]
        };
      } else { 
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
          ]
        };
      }

      this.$nextTick(() => {
        this.$htmlToPaper("imprimir-prescricao", configPrint, () => {});
      });
    },
    updateDados(dados) {
      this.pageSize = dados.pageSize;
    }
  },
  computed: {
    // styleView() {
    //   if (this.pageSize == "A4") {
    //     return "width:210 mm; height: 297mm;";
    //   } else {
    //     return "width:148 mm; height: 210mm;";
    //   }
    // },
    refs() {
      return this.$util.gerarRandomString(9, "modalPrescricao");
    }
  },
  mounted() {
    this.unidade = this.$store.state.unidade;
  }
};
</script>

<style></style>
